import { Pill } from "@/components/ui/pill";
import { isLive, statusLabel, statusTone } from "./status";
import type { ExperimentSummary } from "./types";

export function ExperimentStatusPill({
  experiment,
}: {
  experiment: Pick<ExperimentSummary, "status" | "stop_reason">;
}) {
  return (
    <Pill tone={statusTone(experiment.status)} dot={isLive(experiment.status)}>
      {statusLabel(experiment)}
    </Pill>
  );
}
